import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _opt_ from "@Elementos/Opciones";
import Filtros from "@Composicion/Filtros/Filtros";
import Cuerpo from "@Composicion/Cuerpo/Cuerpo";
import Opciones from "@Composicion/Opciones/Opciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./VentaTienda.css";

function VentaTienda(){
  const [titulo, setTitulo] = useState("Venta en Tienda")
  // const [v_u, ev_u] = useState({
  //   procesando_formulario: false,
  //   procesando_api_personal: true,
  //   mostrar_modal: false,
  //   datos_tabla: null,
  // });
  // const { ecv_u } = useContext(Contexto);
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [v_u,ev_u] = useState({})
  useEffect(() => {
    const personaCrud = _api_.f_personasCRUD({parametros:{ modo: "DSG" }, timeout:3000});
    
    personaCrud.respuesta.then((dPC) => {
      ecv_u(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, { datos_tabla: dPC.contenido });
        console.log(dPC);
        console.log(dPC.contenido);
      }
      _f_.asignar(ev_u, { procesando_api_personal: false });
    });
  }, []);
  //--------------------------------------------------------------------------------------------
  // const origenComponente = "VentaEnTienda";
  // //ecv_u FUNCION que establece variables
  // const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);

  // const [v_u, ev_u] = useState({
  //   v_formulario: false,
  //   v_modal: false,
  //   i_procesandoApiCarga: true,
  //   do_datosTabla: {},
  //   do_filtros: {},
  //   do_seleccionados: {},
  //   da_precioDeVenta: [
  //     { id: "1", valor: "Tienda" },
  //     { id: "2", valor: "Distribuidor" },
  //     { id: "3", valor: "Personal" },
  //   ],
  //   d_codigoPrecioDeVenta: "1",
  //   d_actualizarTabla: false,
  // });

  // useEffect(() => {
  //   const pedidoTienda = _api_.f_pedidoTienda({
  //     parametros: {
  //       codUsuario: v_u.d_codigoPrecioDeVenta,
  //       tipoDistribucion: 1,
  //     },
  //     origen: origenComponente,
  //     timeout: 5000,
  //   });
  //   pedidoTienda.respuesta.then((dPC) => {
  //     _f_.asignar(ecv_u, dPC, true, origenComponente);
  //     console.log(dPC);
  //     if (!dPC.error) {
  //       _f_.asignar(ev_u, { do_datosTabla: dPC.contenido });
  //     }
  //     _f_.asignar(ev_u, { i_procesandoApiCarga: false });
  //   });
  // }, [v_u.d_codigoPrecioDeVenta, v_u.d_actualizarTabla]);

  // useEffect(() => {
  //   //console.log(v_u.do_filtros);
  //   //console.log(v_u);
  //   console.log(v_u.do_seleccionados);
  //   //console.log(cv_u);
  // }, [v_u.do_seleccionados,v_u.do_filtros]);


  // if (v_u.i_procesandoApiCarga)
  //   return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;
  //-----------------------------------------------------------------------------------------------------

  if (v_u.procesando_api_personal)
    return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;
  return(
    <div className="contenedor">
      <div className="titulo">{titulo ?? "No establecido"}</div>
      <Filtros filtros = {v_u.datos_tabla.filtros}/>
      <Cuerpo/>
      <Opciones/>
    </div>    
  )
}
export default VentaTienda;